import { render } from "./index.vue?vue&type=template&id=595dd2de&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=595dd2de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595dd2de"],['__file',"src/components/CascaderArea/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "595dd2de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('595dd2de', __exports__)) {
    api.reload('595dd2de', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=595dd2de&scoped=true", () => {
    api.rerender('595dd2de', render)
  })

}


export default __exports__